import apiClient from '@/services/axios'

export async function post(venueSetupId, destinationSetupName) {

  var response = await apiClient.post(process.env.VUE_APP_MARCOM_API_BASE_URL + `/admin/venue-setups/${venueSetupId.id}/copy/${destinationSetupName}`);

  if (response) {
    console.log(response)
    return response.data;
  }

  throw new Error('Unable to copy venue setup.')
}
